module.exports = __webpack_public_path__ + "img/22.b0e84c3c.jpg";